import React, { FC, ReactNode } from 'react'
import { Container, Effect, Spacer, Text, parsers, Icon, Button, Faq as FaqBase } from 'roadie-ui'
import { Theme } from './types'
import styled from 'styled-components'
import { SUPPORT_PHONE_NUMBER } from 'util/constants'
import { formatPhone } from 'util/format'

const FooterHeader:FC<{children:ReactNode}> = props => (
  <Container.Base>
    <Text.H5 $color="lookup:footerfg">{props.children}</Text.H5>
    <Spacer $height=".8rem" />
    <Effect.Opacity $opacity=".5">
      <Container.Base $backgroundColor="lookup:footerfg" $height="2px" />
    </Effect.Opacity>
  </Container.Base>
)

const Faq = styled(FaqBase)`
  > * {
    color: ${parsers.color('lookup:footerfg')};
    &::before {
      border-color: transparent transparent transparent ${parsers.color('lookup:footerfg')};
    }
  }
`

const TrackingFooter:FC<{faq:Theme["faq"]}> = props => {
  return (
    <Container.Base>
      <FooterHeader>Common Questions</FooterHeader>
        <Container.Grid
          $gridTemplateColumns="1fr 1fr"
          $gridTemplateColumnsMedia={{mobile: '1fr'}}
          $gridAutoRows="auto"
          $color="lookup:footerfg"
        >
          {props.faq.map(({ q, a }) => (
            <Faq faintNotch key={`faq-${q}`} title={q}><span dangerouslySetInnerHTML={{__html: a}} /></Faq>
          ))}
        </Container.Grid>
      <Spacer $height="3.2rem" />
      <FooterHeader>Still Need Help?</FooterHeader>
      <Spacer $height="1.2rem" />
      <Container.Grid
        $color="lookup:footerfg"
        $gridTemplateColumns="3rem 1fr"
        $gridGap="1rem"
        $alignItems="center"
      >
        <Icon.Phone />
        <Button.A.Tertiary
          $color="lookup:footerfg"
          href={`tel:${SUPPORT_PHONE_NUMBER}`}
        >
            {formatPhone(SUPPORT_PHONE_NUMBER)}
        </Button.A.Tertiary>
      </Container.Grid>
    </Container.Base>
  )
}

export default TrackingFooter